import { BritishColumbiaObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";
import { BritishColumbiaObstetricalVisit } from "@/Patient/Models/ObstetricalFile/BritishColumbia/Part2/BritishColumbiaObstetricalVisit";
import { ObstetricalFileSubsequentVisitsTable } from "../../../../../Common/Subcomponent/ObstetricalFileSubsequentVisitsTable";
import { BritishColumbiaObstetricalFileSubsequentVisitsTableRow } from "./BritishColumbiaObstetricalFileSubsequentVisitsTableRow";

class BritishColumbiaObstetricalFileSubsequentVisitsTable extends ObstetricalFileSubsequentVisitsTable<BritishColumbiaObstetricalFileForm, BritishColumbiaObstetricalVisit> {
    protected readonly clickableContext = BritishColumbiaObstetricalFileClickableTextContext.Section17_SubsequentVisitComment;

    protected get tableContainerStyle(): React.CSSProperties { return { marginTop: 0 }; }

    protected renderTitle(): JSX.Element {
        return <h4 className="section-title margin-none-bottom">17.</h4>;
    }

    protected renderTableHeader(): JSX.Element {
        const commonClassName = "text-bold";

        return (
            <thead>
                <tr>
                    <th className={`${commonClassName} col-medium`}>{this.getString("DateLabel")}</th>
                    <th className={`${commonClassName} col-mediumsmall`}>{this.getString("ObstetricalFile_GestationalAgeAbbrevLabel")}{this.getLabelSuffix("WeeksSlashDaysAbbrevLabel")}</th>
                    <th className={`${commonClassName} col-mediumsmall`}>{this.getString("BloodPressureAbbrevLabel")}</th>
                    <th className={`${commonClassName} col-mediumsmall`}>{this.getString("UrineLabel")}{this.getLabelSuffix("IfIndicatedLabel")}</th>
                    <th className={`${commonClassName} col-mediumsmall`}>
                        {this.getString("WeightAbbrevLabel")}
                        {this.renderWeightUnit(this.props.form.Metadata.SubsequentVisitsTableWeightUnit)}
                    </th>
                    <th className={`${commonClassName} col-mediumsmall`}>{this.getString("FundusLabel")}{this.getLabelSuffix("CentimeterUnitSymbolLabel")}</th>
                    <th className={`${commonClassName} col-mediumsmall`}>{this.getString("FetalHeartRateAbbrevLabel")}{this.getLabelSuffix("PerMinuteTextAbbrevLabel")}</th>
                    <th className={`${commonClassName} col-mediumsmall`}>{this.getString("FetalMovementAbbrevLabel")}</th>
                    <th className={`${commonClassName} col-mediumsmall`}>{this.getString("ObstetricalFile_PresentationAndPositionAbbrevLabel")}</th>
                    <th className={commonClassName}>{this.getString("CommentsLabel")}</th>
                    <th className={`${commonClassName} col-medium`}>{this.getString("NextVisitLabel")}</th>
                    <th className={`${commonClassName} col-medium`}>{this.getString("InitialsLabel")}</th>
                </tr>
            </thead>
        );
    }

    protected renderTableRow(visit: BritishColumbiaObstetricalVisit, index: number): JSX.Element {
        return <BritishColumbiaObstetricalFileSubsequentVisitsTableRow {...this.getTableRowProps(visit, index)} />;
    }

    private getLabelSuffix(label: string): React.ReactNode {
        return <div className="label-suffix extra-info-label">({this.getString(label)})</div>;
    }
}

export { BritishColumbiaObstetricalFileSubsequentVisitsTable };
